import { encode, decode } from "js-base64";
import { recoilPersist } from "recoil-persist";

const localStorageBase64 = () => {
  return {
    setItem: (key: any, value: any) => {
      localStorage.setItem(encode(key), encode(value));
    },
    getItem: (key: any) => {
      const a = localStorage.getItem(encode(key));
      return decode(a || "");
    },
    clear: () => {
      localStorage.clear();
    },
  };
};

const { persistAtom } = recoilPersist({
  key: "persistAtomKey",
  storage: localStorageBase64(),
});

export { persistAtom, localStorageBase64 };
